import * as React from 'react';
import {KeyboardEventHandler, ReactNode, useState} from 'react';
import {IInputFieldProps} from '~/components/Form';
import {classByIntent} from '~/lib/intent';
import style from './index.module.scss';

export interface ITextareaProps extends IInputFieldProps<any> {
    placeholder?: string;
    onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement>;
    className?: string;
    autoFocus?: boolean;
    required?: boolean;
    max?: any;
    min?: any;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, ITextareaProps>(({
    disabled,
    required,
    intent,
    onKeyDown,
    onChange,
    value,
    placeholder,
    id,
    className,
    autoFocus,
    ...otherProps
}, inputRef) => {
    const classes = [style.textarea, className, classByIntent(intent)];

    return <div className={classes.join(' ')}>
        <textarea {...otherProps} value={value || ''}
            autoFocus={autoFocus}
            onChange={event => onChange?.(event.target.value)}
            disabled={disabled}
            required={required}
            placeholder={placeholder}
            id={id}
            onKeyDown={onKeyDown}
            ref={inputRef || undefined}
        />
    </div>
});
